import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Spinner from 'components/Spinner'
import Message from 'components/Message'
import ImageGallery from 'components/ImageGallery/ImageGallery'
import LocationImagesEmptyState from 'components/LocationImagesEmptyState'
import { deletePortfolioImage, getPortfolioImages } from 'slices/portfolioImagesSlice'
import { toast } from 'components/ui/toast-store'

export interface Props {
	className?: string
	/**
	 * Opens the parent's upload wizard from the empty state. Optional because
	 * the container is also rendered where the parent already shows its own
	 * empty state; the button is hidden when it is not supplied, rather than
	 * rendering one that does nothing.
	 */
	onUploadClick?: () => void
	[x: string]: any
}

const PortfolioImageGalleryContainer = ({ className, onUploadClick }: Props) => {
	const dispatch = useDispatch()
	const params = useParams()
	const portfolioid = (params as any).id

	const userLogin = useSelector((state: any) => state.userLogin)
	const { userInfo } = userLogin

	const { portfolioImages, error, loading } = useSelector((state: any) => {
		const portfolio = state.portfolios.entities[portfolioid]
		const images = state.portfolioImages.entities
		return {
			portfolioImages: portfolio?.images?.map(imgId => images[imgId] || {}) || [],
			error: state.portfolioImages.error,
			loading: state.portfolioImages.isLoading,
		}
	})

	const userid = userInfo._id

	useEffect(() => {
		// @ts-ignore
		dispatch(getPortfolioImages(portfolioid))
	}, [dispatch, userid, portfolioid])

	const handleDeleteImage = async (id: string) => {
		if (await toast.confirm({ title: 'Delete image', message: 'Delete this image? This cannot be undone.' }))
			dispatch(deletePortfolioImage(id))
	}

	if (loading) return <Spinner containerHeight="50vh" />
	if (error) return <Message variant="danger">{error}</Message>
	// if (portfolioImages.length === 0) return <Placeholder>1 No Images</Placeholder>

	return (
		<div>
			{portfolioImages.length === 0 ? (
				onUploadClick ? (
					<LocationImagesEmptyState onUploadClick={onUploadClick} />
				) : null
			) : (
				<ImageGallery
					className={className}
					locationImages={portfolioImages}
					handleDeleteImage={handleDeleteImage}
					handlePreviewImage={handleDeleteImage}
				/>
			)}
		</div>
	)
}

export default PortfolioImageGalleryContainer
